<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CandelaControl',
  computed: {
    ...mapGetters([
      'saved_control_value'
    ])
  },
  data() {
    return {
      value: null
    }
  },
  methods: {
    ...mapActions([
      'send_control_value'
    ]),
    on_value_change() {
      this.send_control_value({
        id: this.id,
        component_id: this.component_id,
        type: this.type,
        value: this.value
      })
    },
    on_mounted() {
      const v = this.saved_control_value(this.id)
      if(v !== null && v !== undefined) {
        this.value = v
      } else {
        if(!this.value && this.default) {
          this.value = this.default
        }
      }
    }
  },
  mounted() {
    this.on_mounted()
  },
  props: {
    component_id: {type: String, default: () => null},
    id: {type: String, default: () => null},
    default: {default: () => null},
    label: {type: String, default: () => 'Untitled'},
    parent: {type: String, default: () => null},
    type: {type: String, default: () => null}
  },
  watch: {
    value(curr, prev) {
      if(prev !== null && curr !== prev) {
        this.on_value_change()
      }
    }
  }
}
</script>

<template>
  <div/>
</template>
